import React from 'react';
import styled from 'styled-components';

import { LOCALE_EN, LOCALE_FR } from '@lib/locale';

const LOGO_URL_PER_LOCALE = {
  [LOCALE_EN]: '/assets/brs-logo-en.svg',
  [LOCALE_FR]: '/assets/brs-logo-fr.svg',
};

const BlueRewardsLogoContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const BlueRewardsLogoImage = styled.img`
  display: block;
  height: 40px;

  ${({ $size }) => $size === 'large' && (
    'height: 80px;'
  )}
`;

const BlueRewardsLogoText = styled.span`
  ${({ theme }) => theme.typographyRebrand.body.lg};
  color: ${({ theme }) => theme.c.text.primary};

  ${({ $size, theme }) => $size === 'large' && `
    ${theme.typographyRebrand.body.lg}
    font-size: 40px;
  `}
`;

const BlueRewardsLogo = ({ text, size = 'regular', locale = LOCALE_EN }) => (
  <BlueRewardsLogoContainer>
    <BlueRewardsLogoImage $size={size} src={LOGO_URL_PER_LOCALE[locale] || LOGO_URL_PER_LOCALE[LOCALE_EN]} alt="" />
    {text && <BlueRewardsLogoText $size={size}>{text}</BlueRewardsLogoText>}
  </BlueRewardsLogoContainer>
);

export default BlueRewardsLogo;
